/** Whole dollars, as a price reads: `$3,049`. Shared by server- and
 *  client-rendered homepage pieces, so it lives outside either. */
export function formatUsd(n: number): string {
  return `$${n.toLocaleString('en-US')}`;
}
